exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#map[data-v-be890ada] {\n    max-width: 100%;\n    width: 100%;\n    height: 1150px;\n}\n@media all and (max-width: 585px) {\n#map[data-v-be890ada] {\n        height: 600px;\n}\n}\n.w-100[data-v-be890ada] {\n    max-width: 100%;\n    width: 100%;\n    height: 650px;\n}\n@media all and (max-width: 960px) {\n.w-100[data-v-be890ada] {\n        height: 500px;\n}\n}\n@media all and (max-width: 585px) {\n.w-100[data-v-be890ada] {\n        height: 300px;\n}\n}\n@media all and (max-width: 1275px) {\n.vueperslides[data-v-be890ada] {\n        padding: 0 40px !important;\n}\n}\n", ""]);

// exports
